import {
  LABEL_BARCODE_LEFT_MM,
  LABEL_FOLD_MM,
  LABEL_INFO_LEFT_MM,
  LABEL_PRINT_GAP_MM,
  LABEL_PRINT_HEIGHT_MM,
  LABEL_PRINT_WIDTH_MM,
  mmToDots,
} from './inventoryLabelGeometry';

export interface InventoryLabelEplRow {
  productCodeUnique: string;
  materialLabel: string;
  salePrice: number;
  weightGrams: number | null;
}

function eplText(value: string): string {
  return value
    .replace(/[\r\n"]/g, ' ')
    .trim()
    .slice(0, 40);
}

function formatPriceBs(price: number): string {
  const n = Number(price);
  const s = n.toLocaleString('es-BO', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  return `Bs. ${s}`;
}

function formatWeight(weightGrams: number | null): string {
  if (weightGrams == null || Number.isNaN(Number(weightGrams))) return '-';
  return Number(weightGrams).toLocaleString('es-BO', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

/** EPL: empty 44 mm + two 22 mm panels (barcode | Plata/Bs). */
export function buildSingleLabelEpl(row: InventoryLabelEplRow): string {
  const q = mmToDots(LABEL_PRINT_WIDTH_MM);
  const Qh = mmToDots(LABEL_PRINT_HEIGHT_MM);
  const Qg = mmToDots(LABEL_PRINT_GAP_MM);
  const barX = mmToDots(LABEL_BARCODE_LEFT_MM);
  const infoX = mmToDots(LABEL_INFO_LEFT_MM);
  void LABEL_FOLD_MM;

  const material = eplText(row.materialLabel || '-');
  const price = eplText(formatPriceBs(row.salePrice));
  const weight = eplText(formatWeight(row.weightGrams));
  const code = eplText(row.productCodeUnique || '');

  return [
    'N',
    `q${q}`,
    `Q${Qh},${Qg}`,
    `A${barX},6,0,1,1,1,N,"${code}"`,
    `A${barX + 100},6,0,1,1,1,N,"${weight}"`,
    `B${barX},20,0,1A,2,2,40,N,"${code}"`,
    `A${infoX},12,0,2,1,1,N,"${material}"`,
    `A${infoX},42,0,2,1,1,N,"${price}"`,
    'P1',
    '',
  ].join('\n');
}

export function buildInventoryLabelsEpl(rows: InventoryLabelEplRow[]): string {
  return rows.map(buildSingleLabelEpl).join('');
}
